/**
 * @generated SignedSource<<0cca5159c6cda0d025afd30b07bda0b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type LearnosityInitObjectInput = {
  activityId: string;
  autoSaveAnswers: boolean;
  regions: string;
  renderingType: string;
  responsiveRegions: boolean;
  scrollToTest: boolean;
  scrollToTop: boolean;
  sessionId: string;
  showCorrectAnswers: boolean;
  showDistractorRationale: boolean;
  showIntro: boolean;
  skipSubmitConfirmation: boolean;
  state: string;
  title: string;
  userId: string;
  warningOnChange: boolean;
};
export type IndividualStudentReportInitObjectQuery$variables = {
  initModel: LearnosityInitObjectInput;
  skip: boolean;
};
export type IndividualStudentReportInitObjectQuery$data = {
  readonly getLearnosityInitObject?: string;
};
export type IndividualStudentReportInitObjectQuery = {
  response: IndividualStudentReportInitObjectQuery$data;
  variables: IndividualStudentReportInitObjectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "initModel"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "initModel",
            "variableName": "initModel"
          }
        ],
        "kind": "ScalarField",
        "name": "getLearnosityInitObject",
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IndividualStudentReportInitObjectQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IndividualStudentReportInitObjectQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1cdf01b2de7b1ba60820f1d03ca6d33f",
    "id": null,
    "metadata": {},
    "name": "IndividualStudentReportInitObjectQuery",
    "operationKind": "query",
    "text": "query IndividualStudentReportInitObjectQuery(\n  $initModel: LearnosityInitObjectInput!\n  $skip: Boolean!\n) {\n  getLearnosityInitObject(initModel: $initModel) @skip(if: $skip)\n}\n"
  }
};
})();

(node as any).hash = "66fb0ac34a9e0ee94159b6d6d14a4c62";

export default node;
